import React, { type ForwardedRef, type HTMLAttributes, type ReactNode } from 'react';
import styled, { css } from 'styled-components';
import customCss from '@/app/components/hotel-detail/css/customCss';

type HotelPageContentSectionProps = {
  title?: ReactNode;
  titleId?: string;
  subTitle?: ReactNode;
  children: ReactNode;
  sectionRef?: ForwardedRef<HTMLElement>;
} & HTMLAttributes<HTMLElement>;

export const Title = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('Title3')};
  padding: 0 0 16px;

  @media ${customCss.breakpoints.sm} {
    padding: 12px 0 16px;
  }

  @media ${customCss.breakpoints.xl} {
    ${({ theme }) => theme.kallisto.mixins.font('Title2')};
  }
`;

export function HotelPageContentSection(props: HotelPageContentSectionProps) {
  const { children, title, titleId, subTitle, sectionRef, ...rest } = props;
  const isSubtitleString = typeof subTitle === 'string';
  return (
    <section
      css={css`
        padding: 16px;
        display: flex;
        flex-direction: column;
        margin-top: 16px;

        @media ${customCss.breakpoints.sm} {
          padding: 0 24px;
        }

        @media ${customCss.breakpoints.lg} {
          padding: 0 24px;
        }

        @media ${customCss.breakpoints.lgPlus} {
          padding: 0 40px;
        }

        @media ${customCss.breakpoints.xl} {
          padding: 0;
        }
      `}
      ref={sectionRef}
      {...rest}
    >
      {title || subTitle ? (
        <div
          className="sectionHeader"
          css={css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          `}
        >
          {title ? <Title id={titleId}>{title}</Title> : undefined}
          {subTitle ? (
            isSubtitleString ? (
              <div
                css={css`
                  color: ${({ theme }) => theme.commons.colors.gray400};
                  font-size: ${({ theme }) => theme.commons.font.sizes.medium};
                  font-weight: ${({ theme }) => theme.commons.font.weights.regular};
                `}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={isSubtitleString ? { __html: subTitle as string } : undefined}
              />
            ) : (
              subTitle
            )
          ) : null}
        </div>
      ) : null}

      {children}
    </section>
  );
}

export default HotelPageContentSection;
